import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalService} from '../../../vna_portal/model/PortalService';
import {VnaPortalService} from '../../../vna_portal/services/vna-portal.service';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {PortalServiceFactoryService} from '../../../services/portal-service-factory.service';

import * as _ from 'underscore';

@Component({
  selector: 'app-basic-parameters',
  //templateUrl: './basic-parameters.component.html',
    //templateUrl: '',
  styleUrls: ['./basic-parameters.component.scss']
})
export abstract class BasicParametersComponent implements OnInit {

    @Input() portalService: PortalService;
    @Input() type: string = 'portal';
    form: FormGroup;
    enabled: boolean = false;
    submitted: boolean = false;

    portalCampHandler: any;

    constructor(protected fb: FormBuilder, protected portalCampFactory: PortalServiceFactoryService, protected alertHandler: AlertaService) {

        this.form = this.fb.group({
            area_checker: new FormControl('', Validators.required),
            norm_engine: new FormControl(),
            callback_response: new FormControl(),
            landline_verifier: new FormControl(),
            mobile_verifier: new FormControl(),
            max_attempts: new FormControl(),
            tarification_type: new FormControl('secs'),
        });

    }

    savePortalService(): void {

        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService };
        if(_.indexOf(['camp', 'action'], this.type) >= 0){
            criteria['camp_pk'] = this.portalService.pkCamp;
            if(this.type == 'action'){
                criteria['action_pk'] = this.portalService['pkAction'];
            }
        }

        this
            .portalCampFactory
            .getHandler(this.type)
            .savePortalService(criteria, 'basic_parameters', this.portalService.alias, this.form.value)
            .subscribe(
                (result) => {
                    this.enabled = false;
                    this.alertHandler.addAlert('success', 'Basic parameters have been saved successfully');
                }
            )
    }

    ngOnInit() {
        this.form.controls['area_checker'].setValue(this.portalService.getConfigKey('area_checker', ''));
        this.form.controls['norm_engine'].setValue(this.portalService.getConfigKey('norm_engine', ''));
        this.form.controls['callback_response'].setValue(this.portalService.getConfigKey('callback_response', 0));
        this.form.controls['landline_verifier'].setValue(this.portalService.getConfigKey('landline_verifier', 0));
        this.form.controls['mobile_verifier'].setValue(this.portalService.getConfigKey('mobile_verifier', 1));
        this.form.controls['max_attempts'].setValue(this.portalService.getConfigKey('max_attempts', 3));
        this.form.controls['tarification_type'].setValue(this.portalService.getConfigKey('tarification_type', 3));

        if(this.type === 'camp'){
          this.form.setControl('do_not_allow_extra_services', new FormControl());
          this.form.controls['do_not_allow_extra_services'].setValue(this.portalService.getConfigKey('do_not_allow_extra_services', 0));

        }
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/basic-parameters/basic-parameters.component.ts